import { render, staticRenderFns } from "./vw_student_overall_class.vue?vue&type=template&id=50cfec2c&scoped=true&"
import script from "./vw_student_overall_class.vue?vue&type=script&lang=js&"
export * from "./vw_student_overall_class.vue?vue&type=script&lang=js&"
import style0 from "./vw_student_overall_class.vue?vue&type=style&index=0&id=50cfec2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cfec2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VBtn,VCard,VCardText,VChip,VContainer,VDataTable,VProgressLinear})
